import { OmyConst } from "../../OmyConst";
import Omy from "../../Omy";
import OContainer from "../OContainer";

export default class ORevoltParticleSequence extends OContainer {

    constructor(revoltName, delay = 0, autoStart = true, scaleMod = 1) {
        super();

        this._oType = OmyConst.OMY_REVOLT_SEQUENCE;

        this._delay = delay;
        this._autoStart = autoStart;
        this._scaleMod = scaleMod;
        this._revoltName = revoltName;
        this._createParticles();
        if (Omy.debugMode) {
            this._isOnDebugerUpdate = true;
            Omy.addUpdater(this._updateDebug, this);
        }
        this.aa_isRegOnDebug = false;
        this._inDebug = false;
    }

    /**     * @private     */
    _updateDebug() {
        if (this.aa_isRegOnDebug && !this._inDebug) {
            Omy.add.regDebugMode(this);
        } else if (!this.aa_isRegOnDebug && this._inDebug) {
            Omy.add.removeFromDebug(this);
        }
    }

    /** @private */
    _createParticles() {
        if (!this._particle) {
            this._particle = Omy.revolt(this._revoltName).getEffectSequence(this._revoltName);
            this._particle.init(this, this._delay, this._autoStart, this._scaleMod);
        }
    }

    /** @private */
    _destroyParticles() {
        if (this._particle) {
            this._particle.recycle();
            this._particle = null;
        }
    }

    /** @public */
    forceParticleUpdate() {
        if (this._particle) {
            for (let i = 0; i < 1000; i++) {
                this._particle.update(1 / 60);
            }
        }
    }

    revive() {
        super.revive();
        this._createParticles();
        if (Omy.debugMode && !this._isOnDebugerUpdate) {
            this._isOnDebugerUpdate = true;
            Omy.addUpdater(this._updateDebug, this);
        }
        return this;
    }

    kill() {
        this._destroyParticles();
        if (this._isOnDebugerUpdate) {
            this._isOnDebugerUpdate = false;
            Omy.removeUpdater(this._updateDebug, this);
        }
        super.kill();
        return this;
    }

    destroy(options) {
        this._destroyParticles();
        if (this._isOnDebugerUpdate) {
            this._isOnDebugerUpdate = false;
            Omy.removeUpdater(this._updateDebug, this);
        }
        this.removeAll();
        this._revoltName = null;
        super.destroy(options);
        return this;
    }

    /** @public */
    start() {
        this._particle && this._particle.start();
    }

    /** @public */
    addStarted(func, context, once) {
        if (!this._particle) {
            console.error("particle not exists!");
            return;
        }
        if (once) this._particle.on.started.addOnce(func, context);
        else this._particle.on.started.add(func, context);
    }

    /** @public */
    addCompleted(func, context, once) {
        if (!this._particle) {
            console.error("particle not exists!");
            return;
        }
        if (once) this._particle.on.completed.addOnce(func, context);
        else this._particle.on.completed.add(func, context);
    }

    /** @public */
    removeStarted(func) {
        if (!this._particle) return;
        this._particle.on.started.remove(func);
    }

    /** @public */
    removeCompleted(func) {
        if (!this._particle) return;
        this._particle.on.completed.remove(func);
    }

    get particle() {
        return this._particle;
    }
}
